// NAVIGATION
jQuery($ => {
	const $burger = $('.hamburger');
	const $keyboardNav = $('.keyboard-nav');

	// Check if the child menu is off screen
	const checkMenuPosition = (e) => {
		if(e.parent().find('.header-nav__ul').length){
			const menu = e.parent().find('.header-nav__ul');
			const menuOffset = parseFloat(menu.offset().left) + parseFloat(menu.css('width'));

			if(menuOffset > $(window).width()){
				menu.addClass('header-nav__ul--right');
			}
		}
	};

    $burger.on('click', () => {
        document.body.classList.toggle('nav-active');
		if($('#adminBar').length){
			$('#adminBar').collapse('toggle');
		}
    });

	$(document).on('focus', '.header-nav__link', function(e){
		$(this).parents('.header-nav__ul').addClass('focussed');

		checkMenuPosition($(this));
	});
	$(document).on('blur', '.header-nav__link', function(e){
		$('.header-nav__ul').removeClass('focussed');
	});
	$(document).on('mouseover', '.header-nav__link', function(e){
		checkMenuPosition($(this));
	});
});
